<template>
  <div
    :class="['copy-clipboard', props.className]"
    :style="[props.inlineStyles]"
    :data-clipboard-text="props.clipboard"
    @click="onCopyClipboard"
  >
    <img :src="props.srcImage" alt="Icon" />
  </div>
</template>

<script setup>
// Import library
import ClipboardJS from "clipboard";
const { $functions } = useNuxtApp();

// Component name
const componentName = "CopyClipboard";

// Component props types: String, Number, Boolean, Array, Object, Function, Promise
const props = defineProps({
  className: {
    type: String,
  },
  inlineStyles: {
    type: Object,
    default: function () {
      return {
        // Style
      };
    },
  },
  clipboard: {
    type: String,
    default: "Input your clipboard at props > clipboard",
  },
  srcImage: {
    type: String,
    default: "/images/icons/ic-copy-clipboard.svg",
  },
});

// Use library
new ClipboardJS(".copy-clipboard");

const onCopyClipboard = () => {
  $functions.notify.info({ text: 'Copied to clipboard!' });
  // You can add additional actions here if needed when the copy action is triggered
};
</script>

<style lang="scss">
.copy-clipboard {
  /* Parent style   ------------------------------ */
  cursor: pointer;
  position: absolute;
  z-index: 1;
  top: rem(4);
  right: rem(4);

  &:active {
    img {
      transform: scale(0.9);
      opacity: 0.5;
    }
  }

  /* Children style ------------------------------ */
  img {
    transition: $transition;
    transform-origin: center;
  }

  /* Modifier style ------------------------------ */
  /* Other component style ----------------------- */
}
</style>
